import React from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import LinearScale from './LinearScale';
import MultiScale from './MultiScale';
import styles from './SpotDescriptor.module.scss';

interface Option {
  name: string;
  value: boolean;
}

interface Props {
  headingComponent?: 'h3' | 'h4';
  kind: string;
  value: string;
  scale?: number;
  options: Option[] | string[];
  description: string;
}

const SpotDescriptor: React.FC<Props> = ({
  headingComponent = 'h4',
  kind,
  value,
  scale = 0,
  options,
  description,
}) => {
  const linearScale = options.length === 2;
  const percentage = (scale / 10) * 100;

  return (
    <Box
      className={classNames({
        [styles.descriptor]: true,
        [styles.multi]: !linearScale,
      })}
      data-testid="spot-descriptor"
    >
      <Typography component={headingComponent} variant="footnote" className={styles.heading}>
        {kind}
      </Typography>
      <Typography component="p" variant="headline" className={styles.value}>
        {value}
      </Typography>
      <Box className={styles.scale}>
        {linearScale ? <LinearScale percentage={percentage} /> : <MultiScale options={options} />}
        <Box className={styles.scaleLegend}>
          {options.map((option) => {
            let name;
            if (linearScale) {
              name = option;
            } else if (typeof option === 'string') {
              name = option;
            } else {
              name = option.name;
            }
            const spanKey = typeof option === 'string' ? option : option.name;
            return (
              <Typography
                component="span"
                variant="caption2"
                className={styles.scaleLegenditem}
                key={spanKey}
              >
                {typeof name === 'string' ? name : name.toString()}
              </Typography>
            );
          })}
        </Box>
      </Box>
      <Typography component="p" variant="footnote" className={styles.description}>
        {description}
      </Typography>
    </Box>
  );
};

export default SpotDescriptor;
